import { z } from "zod";
import { bottleFormatSchema } from "./lot.js";
/**
 * The bottles most recently recorded as drunk, newest first.
 *
 * `statistics.ts` answers *how much, and of what* by the year; this answers
 * *what did we open last*, which is a list of evenings and not a distribution.
 * It is its own contract because the two are asked on different pages and
 * nothing about one is a reason to fetch the other.
 *
 * **One row per drinking that stands.** A bottle drunk, undone and drunk again
 * is one row, on the second evening — the rule `drunk.ts` applies, here applied
 * to the single event rather than to a year's count.
 */
export const recentlyDrunkRowSchema = z.object({
    /** The `Consumed` event, so a row has an identity that is not the bottle's. */
    eventId: z.string(),
    bottleId: z.string(),
    /**
     * The day it was drunk, `YYYY-MM-DD`. A day and not an instant: the event
     * stores midnight UTC for a date the user typed, and a local-time conversion
     * would move it.
     */
    drunkOn: z.string(),
    format: bottleFormatSchema,
    wineId: z.string(),
    wineNumber: z.number().int(),
    wineName: z.string(),
    producer: z.string(),
    vintage: z.number().int().nullable(),
    isNonVintage: z.boolean(),
    /**
     * Who recorded it. Null for a drinking no user performed — the
     * spreadsheet's — and for one whose account has since gone.
     */
    recordedBy: z.string().nullable(),
});
export const recentlyDrunkResponseSchema = z.object({
    /** Newest drinking first, at most `limit` rows. */
    bottles: recentlyDrunkRowSchema.array(),
    /** How many rows the server was willing to send; the page says so when full. */
    limit: z.number().int().positive(),
});
//# sourceMappingURL=drunk-list.js.map